// Oracle normalizer — routes Oracle connections through the per-dialect
// tree-sitter grammar fork (resources/tree-sitter/oracle.wasm) instead of the
// legacy unified scanner. PRD: Ralph/SqlGrammar2/PRD.md Slice 1.5.
//
// Slice 3.5 collapsed the previously-duplicated body into
// `normalize/shared/createForkNormalizer.ts` — this module now binds the
// factory to the Oracle parser singleton and re-exports the loader seams.

import { createForkNormalizer } from '../shared/createForkNormalizer';
import { getOracleParser } from './parser';

const normalizer = createForkNormalizer({ engine: 'oracle', getParser: getOracleParser });

export const buildParsedDocument = normalizer.buildParsedDocument;
export const getDocumentStructure = normalizer.getDocumentStructure;

export { setOracleWasmLoader, getOracleParser, __resetOracleParserForTest } from './parser';
export type { OracleWasmLoader } from './parser';
